<template>
  <v-app-bar
    app
    fixed
    dense
    clipped-left
    color="light-blue lighten-4"
  >
    <!--    <v-app-bar-nav-icon @click="toggleMenuDrawer"></v-app-bar-nav-icon>-->

    <v-toolbar-title>Rocket Rides</v-toolbar-title>
    <v-row
      class="ma-0 pa-0"
      justify="center"
      align="center"
    />
    <v-spacer />

    <v-toolbar-items>
      <v-btn
        icon
      >
        <v-icon>search</v-icon>
      </v-btn>

      <v-btn
        icon
        @click="setCartIsOpen(!isCartOpen)"
      >
        <v-icon>shopping_cart</v-icon>
      </v-btn>
    </v-toolbar-items>
  </v-app-bar>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import PublicHeaderBarMenu from '@/components/HeaderBar/PublicHeaderBarMenu.vue'


export default {
  components: {
    PublicHeaderBarMenu
  },
  data() {
    return {
      menu: false,
      title: ''
    }
  },
  computed: {
    ...mapGetters([ 'isLoading', 'isLoggedIn', 'isCartOpen' ])
  },
  watch: {
    $route(to) {
      // react to route changes...
      this.title = to.meta.pageTitle
    }
  },
  methods: {
    ...mapActions(['setCartIsOpen']),
    toggleMenuDrawer() {
      this.$store.commit('toggleMenuDrawer')
    },
  }
}
</script>
